export function formatDate(dateValue, format) {
  if (!dateValue) {
    return ""
  }

  if (!format) {
    format = 'yyyy-mm-dd hh:mm:ss'
  }

  const date = new Date(dateValue)

  const yyyy = date.getFullYear()
  let mm = date.getMonth() + 1
  let dd = date.getDate()
  let hh = date.getHours()
  let min = date.getMinutes()
  let ss = date.getSeconds()

  return format.replace('yyyy', yyyy)
    .replace('mm', mm < 10 ? `0${mm}` : mm)
    .replace('dd', dd < 10 ? `0${dd}` : dd)
    .replace('hh', hh < 10 ? `0${hh}` : hh)
    .replace('mm', min < 10 ? `0${min}` : min)
    .replace('ss', ss < 10 ? `0${ss}` : ss)
}

export function formatDateYYMMDDHHmmss(dateValue, format) {
  if (!dateValue) {
    return ""
  }

  if (!format) {
    format = 'yyyymmddhhmmss'
  }

  const date = new Date(dateValue)

  const yyyy = date.getFullYear()
  let mm = date.getMonth() + 1
  let dd = date.getDate()
  let hh = date.getHours()
  let min = date.getMinutes()
  let ss = date.getSeconds()

  return format.replace('yyyy', yyyy)
    .replace('mm', mm < 10 ? `0${mm}` : mm)
    .replace('dd', dd < 10 ? `0${dd}` : dd)
    .replace('hh', hh < 10 ? `0${hh}` : hh)
    .replace('mm', min < 10 ? `0${min}` : min)
    .replace('ss', ss < 10 ? `0${ss}` : ss)
}

export function formatDateYYMMDDTHHmmss(dateValue, format) {
  if (!dateValue) {
    return ""
  }

  if (!format) {
    format = 'yyyy-mm-ddThh:mm:ss'
  }

  const date = new Date(dateValue)

  const yyyy = date.getFullYear()
  let mm = date.getMonth() + 1
  let dd = date.getDate()
  let hh = date.getHours()
  let min = date.getMinutes()
  let ss = date.getSeconds()

  return format.replace('yyyy', yyyy)
    .replace('mm', mm < 10 ? `0${mm}` : mm)
    .replace('dd', dd < 10 ? `0${dd}` : dd)
    .replace('hh', hh < 10 ? `0${hh}` : hh)
    .replace('mm', min < 10 ? `0${min}` : min)
    .replace('ss', ss < 10 ? `0${ss}` : ss)
}
